import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoorbellIcon(props: IconProps) {
    return <Icon {...props} iconKey={"doorbell"}/>
}
